/* eslint-disable */
import React from 'react'
import SelectionOverlay from './SelectionOverlay'
import LanguageOverlay from './LanguageOverlay'
import platform from '../utils/platform'
import {
  Text,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
  Button,
  Animated,
  Dimensions,
  Linking,
  Easing,
} from 'react-native'

const height = Math.max(Dimensions.get('window').width, Dimensions.get('window').height)

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: 'white',
    zIndex: 10,
  },
  
  scrollContainer: {
    overflow: 'auto',
    width: '100%',
    height: '100%',
    maxHeight: 680,
    alignItems: 'center',
    alignSelf: 'flex-end',
  },
  
  container: {
    flex: 1,
    paddingTop: 45,
    paddingLeft: 20,
    paddingRight: 20,
    width: '100%',
    maxWidth: 360,
  },
  
  caption: {
    marginTop: 20,
    paddingTop: 10,
    paddingBottom: 10,
    fontWeight: '600',
    fontSize: 12,
    color: 'black',
  },
  
  fakedCaption: {
    position: 'absolute',
    left: 2,
    top: 25,
    fontWeight: '600',
    fontSize: 12,
    zIndex: -1,
    color: 'black',
  },
  
  doneContainer: {
    position: 'absolute',
    top: 7,
    right: 5,
    zIndex: 1,
    paddingRight: 10,
    paddingLeft: 10,
    paddingBottom: 10,
    paddingTop: 10,
  },
  
  done: {
    color: 'black',
    fontWeight: 'bold',
    fontSize: 18,
  },
  
  value: {
    borderBottomWidth: 3,
    marginBottom: 20,
  },
  
  valueText: {
    fontSize: 24,
    color: 'black',
  },
  
  info: {
    paddingLeft: 3,
    paddingBottom: 2,
  },
  
  infoText: {
    fontSize: 10,
  },
  
  bottom: {
    flexGrow: 1,
    justifyContent: 'flex-end',
    paddingBottom: 50,
    marginTop: 30,
  },
  
  link: {
    textDecorationLine: 'underline'
  },
  
  bottomText: {
    lineHeight: 22,
    color: 'black',
  },
  
  group: {
    flexDirection: 'row',
    borderWidth: 1,
    marginTop: 10,
  },
  
  groupItem: {
    flex: 1,
    textAlign: 'center',
    fontWeight: '500',
    paddingTop: 10,
    paddingBottom: 10,
    userSelect: 'none',
  },
  
  groupItemActive: {
    backgroundColor: 'black',
    color: 'white',
  },
})

export default class SettingsOverlay extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      showSelectionOverlay: false,
      selectionType: '',
    }
    
    this.verticalSwipe = new Animated.Value(this.props.show ? 0 : height)
    this.showReminder = false
  }
  
  componentWillReceiveProps(nextProps) {
    Animated.timing(this.verticalSwipe, {
      toValue: nextProps.show ? 0 : height,
      duration: 200,
      easing: Easing.ease,
    }).start()
  }
  
  onChangeUserId() {
    const userId = window.prompt('Enter new User ID')
    
    if (userId >= 100000 && userId <= 999999) {
      this.props.emit('changeUserId', { userId })
    }
  }
  
  getOptions(type) {
    let languages = ['english', 'french', 'german', 'italian', 'russian', 'spanish']
    
    return [
      ...(type == 'additional' ? [{ label: 'none', value: 'none' }] : []),
      ...languages.map(language => ({
        label: language,
        value: language
      }))
    ]
  }
  
  getHeading(type) {
    const headings = {
      'original': 'language you are learning',
      'translated': 'language you know',
      'additional': 'additional language',
    }
    
    return headings[type]
  }
  
  onCancel() {
    this.setState({
      showSelectionOverlay: false
    })
  }
  
  onPressEmail() {
    window.open('mailto:contact@duoreading.io')
  }
  
  onPressAppStoreLink() {
    window.open('https://apps.apple.com/app/id1419671135')
  }
  
  onPressGooglePlayLink() {
    window.open('https://play.google.com/store/apps/details?id=com.duoreading')
  }
  
  onSelect(type, value) {
    this.props.emit('languageSelection', {
      original: this.props.languages.original,
      translated: this.props.languages.translated,
      additional: this.props.languages.additional,
      [type]: value
    })
    
    this.setState({
      showSelectionOverlay: false
    })
  }
  
  onPressValue(type) {
    switch(type) {
      case 'reminder-enabled':
        this.props.emit('enableReminder', {
          settingsPrompt: true
        })
      break
      
      case 'reminder-disabled':
        this.props.emit('disableReminder')
      break
      
      default:
        this.setState({
          showSelectionOverlay: true,
          selectionType: type
        })
    }
  }
  
  onDone() {
    this.props.onClose()
  }
  
  showInfo(type) {
    if (type == 'additional-language') {
      const language = this.props.languages.translated.slice(0, 1).toUpperCase() + this.props.languages.translated.slice(1)
      window.alert(`When you tap on words in ${language} they will be translated to the selected additional language. Use it if ${language} isn't your native language.`, [{ text: 'OK' }])
    }
  }
  
  render() {
    return (
      <Animated.View
        style={[styles.overlay, {
          transform: [{
            translateY: this.verticalSwipe
          }]
        }]}>
        
        <TouchableWithoutFeedback onPress={this.onDone.bind(this)}>
          <View style={styles.doneContainer}>
            <Text style={styles.done}>Done</Text>
          </View>
        </TouchableWithoutFeedback>
      
        {this.state.showSelectionOverlay && this.state.selectionType != 'languages' &&
          <SelectionOverlay
            show={this.state.showSelectionOverlay && this.state.selectionType != 'languages'}
            onCancel={this.onCancel.bind(this)}
            ableToClose={true}
            options={this.getOptions(this.state.selectionType)}
            heading={this.getHeading(this.state.selectionType)}
            onSelect={this.onSelect.bind(this, this.state.selectionType)}>
          </SelectionOverlay>
        }
        
        {this.state.showSelectionOverlay && this.state.selectionType == 'languages' &&
          <LanguageOverlay
            show={this.state.showSelectionOverlay && this.state.selectionType == 'languages'}
            availableLanguagePairs={this.props.availableLanguagePairs}
            ableToClose={true}
            emit={this.props.emit}
            onClose={this.onCancel.bind(this)}>
          </LanguageOverlay>
        }
        
        <View style={styles.scrollContainer}>
          <View style={styles.container}>
            <View style={styles.selectionContainer}>
              <Text style={styles.caption}>LANGUAGES</Text>
              <TouchableWithoutFeedback onPress={this.onPressValue.bind(this, 'languages')}>
                <View style={styles.value}>
                  <Text style={styles.valueText}>
                    {this.props.languages.original} – {this.props.languages.translated}
                  </Text>
                </View>
              </TouchableWithoutFeedback>
            </View>
            
            <View style={styles.selectionContainer}>
              <Text style={styles.caption} onPress={this.showInfo.bind(this, 'additional-language')}>
                ADDITIONAL LANGUAGE
              </Text>
              
              <Text style={styles.fakedCaption} pointerEvents='none'>
                <Text style={{opacity: 0, color: 'white', textShadowColor: 'white'}}>ADDITIONAL LANGUAGE</Text>
                <Text style={styles.infoText}>(?)</Text>
              </Text>
              
              <TouchableWithoutFeedback onPress={this.onPressValue.bind(this, 'additional')}>
                <View style={styles.value}>
                  <Text style={styles.valueText}>{this.props.languages.additional}</Text>
                </View>
              </TouchableWithoutFeedback>
            </View>
            
            <View style={styles.selectionContainer}>
              <Text style={styles.caption}>USER ID</Text>
              <TouchableWithoutFeedback onPress={this.onChangeUserId.bind(this)}>
                <View style={styles.value}>
                  <Text style={styles.valueText}>
                    {this.props.settings.userId}
                  </Text>
                </View>
              </TouchableWithoutFeedback>
            </View>
            
            {this.showReminder &&
            <View style={styles.selectionContainer}>
              <Text style={styles.caption}>REMINDER</Text>
              
              <View style={styles.group}>
                <Text style={[styles.groupItem, this.props.settings.reminderEnabled ? styles.groupItemActive : {}]}
                      onPress={this.onPressValue.bind(this, 'reminder-enabled')}>
                  ENABLED
                </Text>
                
                <Text style={[styles.groupItem, !this.props.settings.reminderEnabled ? styles.groupItemActive : {}]}
                      onPress={this.onPressValue.bind(this, 'reminder-disabled')}>
                  DISABLED
                </Text>
              </View>
            </View>
            }
            
            <View style={styles.bottom}>
              <Text style={styles.bottomText}>
                Questions, suggestions?{'\n'}
                Drop a line at <Text onPress={this.onPressEmail.bind(this)} style={styles.link}>contact@duoreading.io</Text>{'\n'}
                and get app on <Text style={styles.link} onPress={this.onPressAppStoreLink.bind(this)}>App Store</Text> and <Text style={styles.link} onPress={this.onPressGooglePlayLink.bind(this)}>Google Play</Text>
              </Text>
            </View>
          </View>
        </View>
      </Animated.View>
    )
  }
}
